import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  imageSrc?: string;
  content: React.ReactNode;
  buttonText: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, imageSrc, content, buttonText }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="relative flex flex-col gap-4 max-w-md p-6 bg-white rounded-2xl shadow-lg">
        <h2 className="text-2xl text-center font-bold text-black">{title}</h2>
        {imageSrc && (
          <img
            src={imageSrc}
            alt="Modal Content"
            className="w-full h-auto rounded-2xl mb-4 mx-auto"
          />
        )}
        <div className="">
          {content}
        </div>
        {/*
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl font-bold text-black hover:text-gray-600"
        >
          &times;
        </button>
        */}
        <button
          onClick={onClose}
          className="w-full py-2 bg-black text-white font-semibold rounded-2xl hover:bg-gray-800 cursor-pointer"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default Modal;
